// src/utils/errorMessages.ts
export const ErrorMessages = {
  businessName: {
    required: 'Business name is required',
    invalid: 'Enter valid Business name'
  },
  businessType: {
    required: 'Business type is required',
  },
  email: {
    required: 'Email is required',
    invalid: 'Valid email is required'
  },
  password: {
    required: 'Password is required',
    invalid: 'Password must have at least one uppercase letter, one number, one special character, and be at least 8 characters long'
  },
  confirmPassword: {
    required: 'Confirm password is required',
    mismatch: 'Passwords do not match'
  },
  targetWebsite: {
    required: 'Website link is required',
    invalid: 'Invalid website link (e.g., "www.xyz.com")'
  },
  companyName: {
    required: 'Company name is required',
    invalid: 'Company name must be between 2 and 100 characters'
  },
  tin: {
    required: 'GST number is required'
  },
  contactNumber: {
    required: 'Contact number is required',
    invalid: 'Contact number must be 10 digits'
  },
  whatsAppNumber: {
    required: 'WhatsApp number is required',
    invalid: 'WhatsApp number must be 10 digits'
  },
  address: {
    required: 'Address is required',
    invalid: 'Address must be between 5 and 255 characters'
  },
  addressState: {
    required: 'State is required'
  },
  addressCountry: {
    required: 'Country is required'
  },
  industry: {
    required: 'Industry name is required.'
  },
  name: {
    required: 'Name is required',
    invalid: 'Name must be between 2 and 100 characters'
  },
  employeeId: {
    required: 'Employee ID is required'
  },
  position: {
    required: 'Position is required'
  },
  question: {
    required: 'Question is required'
  },
  answer: {
    required: 'Answer is required'
  },
  supportEmail: {
    required: 'Email is required',
    invalid: 'Valid email is required'
  },
  orderUuid: { required: 'Order Id is required' },
  productUuid: { required: 'Product Id is required' },
  title: { required: 'Title is required' },
  message: { required: 'Message is required' },
  customerUuid: { required: 'Customer Id is required' },
  location: { required: 'Location is required' },
  dateTimeFormat: {required: 'Date Time Format selection is required'}
};
